module.exports = __webpack_public_path__ + "media/images/join-5 2-cb8f76215fcd76f02644f0ecd2756f0f.jpg";